// Tiny sound-effects service — synthesized with WebAudio, no audio files.
// Respects the user's "Sounds" setting (localStorage sfxOn, default on).
let ctx = null;

function getCtx() {
  if (typeof window === 'undefined') return null;
  if (!ctx) {
    try {
      const AC = window.AudioContext || window.webkitAudioContext;
      ctx = new AC();
    } catch {
      return null;
    }
  }
  if (ctx.state === 'suspended') ctx.resume().catch(() => {});
  return ctx;
}

export function sfxEnabled() {
  return localStorage.getItem('sfxOn') !== '0';
}

export function setSfxEnabled(on) {
  localStorage.setItem('sfxOn', on ? '1' : '0');
}

function tone(freq, startIn, dur, type = 'sine', vol = 0.16) {
  const c = getCtx();
  if (!c) return;
  const osc = c.createOscillator();
  const gain = c.createGain();
  const t0 = c.currentTime + startIn;
  osc.type = type;
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0.0001, t0);
  gain.gain.exponentialRampToValueAtTime(vol, t0 + 0.015);
  gain.gain.exponentialRampToValueAtTime(0.0001, t0 + dur);
  osc.connect(gain).connect(c.destination);
  osc.start(t0);
  osc.stop(t0 + dur + 0.05);
}

// Cheerful two-note "ding!"
export function playCorrect() {
  if (!sfxEnabled()) return;
  tone(660, 0, 0.12, 'sine');
  tone(880, 0.09, 0.18, 'sine');
}

// Soft low "bonk" — gentle, not scary
export function playWrong() {
  if (!sfxEnabled()) return;
  tone(220, 0, 0.18, 'triangle', 0.14);
  tone(180, 0.1, 0.2, 'triangle', 0.1);
}

// Little victory arpeggio
export function playWin() {
  if (!sfxEnabled()) return;
  const notes = [523.25, 659.25, 783.99, 1046.5];
  notes.forEach((f, i) => tone(f, i * 0.12, 0.25, 'triangle', 0.15));
  tone(1046.5, 0.55, 0.4, 'sine', 0.12);
}

// Tap/click tick
export function playClick() {
  if (!sfxEnabled()) return;
  tone(500, 0, 0.05, 'square', 0.05);
}
